import { render, staticRenderFns } from "./CustomFieldsIndex.vue?vue&type=template&id=049313bb&"
import script from "./CustomFieldsIndex.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports